import React from "react";
import { Locale } from "@linkfluence/models/locale";
import { DatavizEmbedded } from "@radarly/models/dataviz";
import { IFrame } from "./shared";

export interface SharedWidgetsEmbeddedProps {
  dataviz: DatavizEmbedded;
  height: number;
  locale: Locale;
}

export default function SharedWidgetsEmbedded({
  dataviz,
  height,
}: SharedWidgetsEmbeddedProps) {
  return (
    <IFrame
      title={dataviz.name}
      height={height}
      src={dataviz.url}
      allowFullScreen
    />
  );
}
